import { getStyleByBaseColors, getStyleByBrandColor, getStyleByVariables } from "@next-core/color-theme";
export function customizeColorTheme(theme) {
  if (!theme) {
    return;
  }
  if (theme.brandColor) {
    applyColorTheme({
      type: "brandColor",
      ...theme.brandColor
    });
  } else if (theme.baseColors) {
    applyColorTheme({
      type: "baseColors",
      ...theme.baseColors
    });
  } else if (theme.variables) {
    applyColorTheme({
      type: "variables",
      ...theme.variables
    });
  }
}
export function applyColorTheme(options) {
  const style = [];
  const themes = ["light", "dark"];
  themes.forEach(theme => {
    if (options[theme]) {
      switch (options.type) {
        case "brandColor":
          style.push(getStyleByBrandColor(theme, options[theme]));
          break;
        case "baseColors":
          style.push(getStyleByBaseColors(theme, options[theme], options.backgroundColor));
          break;
        case "variables":
          style.push(getStyleByVariables(theme, options[theme]));
          break;
      }
    }
  });
  if (style.length > 0) {
    const element = document.createElement("style");
    element.textContent = style.join("\n\n");
    document.head.appendChild(element);
    return () => {
      element.remove();
    };
  }
}
//# sourceMappingURL=customizeColorTheme.js.map